// extracted by mini-css-extract-plugin
module.exports = {"testReportContainer":"styles__testReportContainer--2Vec2","red":"styles__red--3GOle","green":"styles__green--25Z-j"};